<template>
    <div>
        <v-text-field v-if="!readOnly"  dense label="Name of Content" hide-details="" v-model="contentTitle" v-on:change="OnChange">
        </v-text-field>
        
        <v-row v-if="!readOnly">
            <v-col>
            <span class="subtitle-1" ><b>Columns</b></span>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn
                color="green"
                dark
                @click="AddNewColumn()"
                small
                width="145px"
                >
                New Column
                <v-icon right dark>fa-plus</v-icon>
                </v-btn>
        </v-row>
       
        <div v-if="!readOnly">
            <v-row class="pa-0" no-gutters="" v-for="(column,i) in filteredColumnArray" :key="i">
                <v-text-field v-model="column.text" dense hide-details="" v-on:change="OnChange">
                </v-text-field>
                <v-btn :disabled="i == filteredColumnArray.length - 1" icon small @click="MoveColumnDown(column,i)">
                    <v-icon color="blue" >fa-arrow-down</v-icon>
                </v-btn>
                <v-btn icon :disabled="i == 0" small @click="MoveColumnUp(column,i)" >
                    <v-icon color="blue">fa-arrow-up</v-icon>
                </v-btn>
                <v-btn icon small @click="RemoveColumn(column,i)">
                    <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
            </v-row>
        </div>

        <v-data-table
            :headers="(readOnly) ? filteredColumnArray : columns"
            :items="items"
            class="elevation-1 pa-0 ma-0"
            :headers-length="2"
            dense
            must-sort
            :sort-by="tableSortBy"
        >
            <template v-slot:top>
            <v-toolbar flat color="white" class="pa-0">
                <v-toolbar-title>{{contentTitle}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!readOnly" width="145px" small color="green" dark class="mb-2" @click="OpenNewItemDialog()">New Item <v-icon right dark>fa-plus</v-icon></v-btn>
                <v-dialog v-model="dialog" max-width="900px">
                <v-card>
                    <v-card-text>
                        <v-container>
                            <v-row class="pb-0">
                                <v-col class="pb-0">
                                <span class="headline">dialogTitle</span>
                                </v-col>
                            </v-row>
                            <v-subheader class="pa-0">
                                Create your new data item here, please fill in the text fields below and press "Add".
                            </v-subheader>
                            <v-row>
                                <v-col cols="6" v-for="(column,index) in filteredColumnArray" :key="index">
                                    <v-text-field  :label="column.text" v-model="editedItem['' + column.value]" ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn width="100px" color="red" text @click="CloseAddDialog()">Close</v-btn>
                        <v-btn width="100px" color="green" text @click="CreateNewItem()">{{(editing) ? 'Update' : 'Add'}}</v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            
            </template>
            <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="EditItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                small
                @click="DeleteItem(item)"
            >
                mdi-delete
            </v-icon>
            </template>
        </v-data-table>
        <v-dialog v-model="confirmDeleteDialog" max-width="400px">
            <v-card>
                <v-card color="primaryDark" dark flat class="pa-3 subtitle-1">
                    Delete Item
                </v-card>
                <v-card-text class="pt-4">
                    Are you sure you want to delete this item?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="confirmDeleteDialog = false">Cancel</v-btn>
                    <v-btn color="red" dark @click="ConfirmDeleteItem()">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    
    name: "ContentDatatable",
    components: {

    },
    computed : {

        filteredColumnArray()
        {
            return this.columns.slice(0,this.columns.length - 1);//.splice(0,this.columns.length - 1);
        }

    },
    data() {
        return {
            select: ['Vuetify', 'Programming'],
            columns: [
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            items : [],
            editedItem : {},
            dialog : false,
            editing : false,
            editIndex : 0,
            contentTitle : "",
            tableSortBy : "",
            confirmDeleteDialog : false,
            itemPendingDelete : null
        }
    },
    props: {
        //Content model to use for datatable content
        content: {
            default : null,
            type : Object
        },
        //Should this table NOT have an editable column
        readOnly: {
            default : true,
            type : Boolean
        }
    },
    mounted() {

        this.OnChange();

    },
    methods:{

        DeleteItem(item)
        {
            this.itemPendingDelete = item;
            this.confirmDeleteDialog = true;
        },
        ConfirmDeleteItem()
        {
            this.confirmDeleteDialog = false;
            const item = this.itemPendingDelete;
            this.itemPendingDelete = null;

            if (item)
            {
                const index = this.items.indexOf(item)
                if (index > -1) this.items.splice(index, 1)
                this.OnChange();
            }
        },
        EditItem(item)
        {
            this.editedItem = item;
            this.dialog = true;
            this.editing = true;
            this.editIndex = this.items.indexOf(item);
        },
        OpenNewItemDialog()
        {
            this.editedItem = {};
            this.dialog = true;
            this.editing = false;
        },
        CreateNewItem()
        {
            if(this.editing)
            {
                this.items[this.editIndex] = this.editedItem;
            }
            else
            {
                this.items.push(this.editedItem);
            }
            
            this.editedItem = {};
            this.dialog = false;
            this.OnChange();
        },
        CloseAddDialog()
        {
            this.dialog = false;
        },
        MoveColumnUp(column, index)
        {
            var orgElement = this.columns[index - 1];
            this.columns[index - 1] =  column;
            this.columns[index] = orgElement;

            this.columns = this.columns.slice();
            this.OnChange();
        },
        MoveColumnDown(column, index)
        {
            var orgElement = this.columns[index + 1];
            this.columns[index + 1] =  column;
            this.columns[index] = orgElement;

            this.columns = this.columns.slice();
            this.OnChange();
        },
        AddNewColumn()
        {
            this.columns.splice(this.columns.length - 1,0,{text : '',sortable : true, value : "" + this.columns.length });
            //this.columns.unshift({text : '',sortable : true, value : "" + this.columns.length });
            this.OnChange();
        },
        RemoveColumn(index)
        {
            this.columns.splice(index,1);
            this.OnChange();
        },
        OnChange()
        {
            var columnsExport = this.columns.slice();
            columnsExport.pop();

            var itemsExport = new Array();

            for (let i = 0; i < this.items.length; i++) {
                var itemArray = new Array();
                for (let c = 0; c < columnsExport.length; c++) {
                    
                    var foundValue = this.items[i]["" + columnsExport[c].value];
                    if(foundValue != null)
                    {
                        itemArray.push("" + foundValue)
                    }
                    else
                    {
                        itemArray.push("");
                    }
                }
                itemsExport.push(itemArray);
            }

            var returnObj = {title : this.contentTitle,columns: columnsExport, rows: itemsExport};
            this.$emit("OnChangeContent",returnObj);
        }

    },
    watch : {

        content :
        {
            immediate : true,
            handler(newVal)
            {
                var rows = new Array();
                //First lets create the row objects from the given column / row data

                for (let r = 0; r < newVal.rows.length; r++) {
                    
                    var rowObj = new Object();
                    for (let c = 0; c < newVal.columns.length; c++) {
                        rowObj["" + newVal.columns[c].value] = newVal.rows[r][c];
                    }

                    rows.push(rowObj);
                }

                this.columns = []; 
                this.columns = newVal.columns.concat(this.columns);
                this.tableSortBy = this.columns[0].value;
                //                newVal.columns;
                this.columns.push({ text: 'Actions', value: 'actions', sortable: false });  

                this.items = rows;
                this.contentTitle = newVal.title;
            }
        }
    }
}
</script> 